module.exports = __webpack_public_path__ + "static/media/editor-icon.696de7b7.svg";